/**
 * 🧪 EXECUTIVE DASHBOARD PREVIEW (testing standalone)
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Componente para testing del sistema ejecutivo sin backend.
 * Útil para desarrollo y validación visual.
 */

import React, { useState } from 'react';
import ExecutiveDashboardPage from './ExecutiveDashboardPage';
import { mockExecutiveTimeTracking, mockExecutiveSales } from '../mockData';
import type { ExecutiveDashboard } from '../types';

const ExecutivePreview: React.FC = () => {
  const [selected, setSelected] = useState<ExecutiveDashboard>(mockExecutiveTimeTracking);
  
  const dashboards = [
    { id: 'tt', name: 'Time Tracking', data: mockExecutiveTimeTracking },
    { id: 'sales', name: 'Ventas', data: mockExecutiveSales }
  ];
  
  return (
    <div style={{ background: '#0f172a', minHeight: '100vh' }}>
      {/* Selector (solo para testing) */}
      <div style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 1000,
        display: 'flex',
        gap: '8px'
      }}>
        {dashboards.map(dash => (
          <button
            key={dash.id}
            onClick={() => setSelected(dash.data)}
            style={{
              padding: '10px 16px',
              background: selected.id === dash.data.id ? '#0ea5e9' : '#334155',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 500
            }}
          >
            {dash.name}
          </button>
        ))}
      </div>
      
      {/* Dashboard ejecutivo */}
      <ExecutiveDashboardPage dashboard={selected} />
    </div>
  );
};

export default ExecutivePreview;
